<template>
    <div v-loading="loading">
        <h4>About me <i v-show="!editMode" class="fas fa-edit pull-right cursor-pointer" @click="editMode=true"></i>
        </h4>
        <p v-if="!editMode" >
            <template v-if="about!==null">{{about}}</template>
            <template v-else>
                Please <a href="javascript:;" @click="editMode=true;">click here</a>  to add information about yourself.
            </template>

        </p>
        <div class="form-group" v-if="editMode">
            <textarea v-model="about" :class="hasErrorClass[hasError]"></textarea>
        </div>
        <div class="form-group text-right" v-if="editMode">
            <button class="btn btn-outline-default btn-outline-secondary mr-3" @click="cancel">Cancel<i class="ml-2 fas fa-close"></i></button>
            <button class="btn btn-default btn-success" @click="update()">Save<i class="ml-2 fas fa-save"></i></button>
        </div>

    </div>
</template>

<script>
    export default {
        mounted() {
            this.about = this.rawAboutMeData;
            this.routes = {
                edit: window.App.routes.api.profile_edit,
                get: window.App.routes.api.profile_show
            };
        },
        props: {
            rawAboutMeData: {required: true},
        },
        data() {
            return {
                about: null,
                hasError: 0,
                hasErrorClass: ['form-control', 'form-control is-invalid'],
                validating: false,
                editMode: false,
                routes: null,
                loading:false,
            }
        },
        watch:{
            about(newVal){
                if(this.validating && this.about.trim()!==""){
                    this.hasError = 1;
                }else {
                    this.hasError = 0;
                }
            }
        },
        methods:{
            cancel(){
                this.$notify({
                    title: 'Info',
                    message: 'Update Canceled',
                    type: 'info'
                });
                this.editMode=false;
                this.refresh();
            },
            update(){
                if(this.validate()){
                    this.loading = true
                    axios.put(this.routes.edit,{about:this.about}).then(response=>{
                        this.loading=false;
                        this.editMode=false;
                        this.validating=false;
                        this.$notify({
                            title: 'Success',
                            message: response.data.response.message,
                            type: 'success'
                        });
                        this.refresh();
                    }).catch(e=>{
                        console.log(e);
                        this.loading = false;
                        this.refresh();
                        this.$notify({
                            title: 'Warning',
                            message: "something wrong please refresh and try again",
                            type: 'warning'
                        });
                    });
                }
            },
            validate(){
                this.validating = true;
                if (this.about!==null && this.about.trim() !== ''){
                    return true;
                }
                this.hasError=1;
                return false
            },
            refresh(){
                // this.about=null;
                axios.get(this.routes.get).then(response=>{
                    this.about = response.data.data.about;
                }).catch(e=>console.log(e));
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/my_profile/AboutMe.vue